import { DesktopSettings } from '@honestica/electron-bridge-typing';
import {
  startAutomaticCleaningOutbox,
  stopAutomaticCleaningOutbox,
} from '@launcher/helpers/desktop';
import { logger } from '@services/logger/logger.service';
import { getIsLifenSendingActivated } from '@store/user/user.selector';
import { all, select, takeLatest } from 'redux-saga/effects';

import { DesktopActions } from '../desktop.action';
import { selectDesktopSettings } from '../desktop.selector';

function* openSaga() {
  const settings: DesktopSettings = yield select(selectDesktopSettings);
  const isLifenSendingActivated: boolean = yield select(getIsLifenSendingActivated);

  const watchPaths: string[] = [];
  if (isLifenSendingActivated) {
    watchPaths.push(settings.watchPath);
  }

  if (watchPaths.length > 0) {
    startAutomaticCleaningOutbox(watchPaths, settings.keepFileDuringXDays);
  } else {
    logger.error('LOGIC', 'No watchPath found to call "startAutomaticCleaningOutbox"');
  }
}

function closeSaga() {
  stopAutomaticCleaningOutbox();
}

export function* cleanOutboxFolderSagas() {
  yield all([takeLatest(DesktopActions.startWatchers.type, openSaga)]);
  yield all([takeLatest(DesktopActions.closeWatchers.type, closeSaga)]);
}
